// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"Carousel_carouselWrapper__IYOM0","dots":"Carousel_dots__5aYbn"};